export default "__VITE_ASSET__CzQiB1eg__"